export default __webpack_public_path__ + "static/media/IMG_5139.16d8ebce.jpg";